import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { PrerecordedMessage } from '@entities/prerecorded-message';
import type { BusPrerecordedMessagesPayload } from '@main/event-listeners/payloads/bus-prerecorded-messages.payload';
import type { FetchPrerecordedMessagesEventPublisher } from './fetch-list-prerecorded-messages.usecase';

export class FetchPrerecordedMessagesPublisher
  implements FetchPrerecordedMessagesEventPublisher
{
  private logger = new Logger();

  async publish(): Promise<PrerecordedMessage[]> {
    const iframe = await BusIframe.getIframe();

    const event: BusEvent = {
      type: 'API.LIST_PRERECORDED_MESSAGES',
    };

    this.logger.info('Publishing bus event', { action: event.type });

    const response = (await BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'API.LIST_PRERECORDED_MESSAGES_FULFILLED',
      target: iframe,
    })) as BusPrerecordedMessagesPayload;

    this.logger.info('Fetched Prerecorded Message from Bus', {
      count: response.prerecordedMessages.length,
    });

    return response.prerecordedMessages;
  }
}
